export const maskString = (inputString, numToMask, numVisibleGaps) => {
  if (inputString.length <= numToMask + 2 * numVisibleGaps) {
    return inputString; // If the input string has fewer characters than required, don't mask it.
  }

  const visibleStart = inputString.slice(0, numVisibleGaps);
  const visibleEnd = inputString.slice(-numVisibleGaps);
  const maskedCharacters = "*".repeat(
    inputString.length - numToMask - 2 * numVisibleGaps
  );

  return visibleStart + maskedCharacters + visibleEnd;
};
